/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";
import updateElement, { updateNarrativeElement } from "../functions/updateElement";
import ReferenceEntry, { DisplayFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import PeriodEntry, { DateTimeEntry, displayStringFromFHIRPeriod, getDateTimeDisplay } from "../datatypeComponents/PeriodEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, getCodeableConceptDisplayForObjectOrArray } from "../datatypeComponents/CodeableConceptEntry";
import { DisplayFromFHIRCodeableReference } from "../datatypeComponents/CodeableReferenceEntry";
import { useEffect, useState } from "react";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { changeTopNavigationElements } from "../slices/navigationPanel/navigationPanelSlice";
import { changeTabMenu } from "../slices/tabPane/tabPaneSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import Spinner from "../components/Spinner";
import NarrativeEntry, { DisplayFromFHIRXhtml } from "../datatypeComponents/NarrativeEntry";
import { displayStringFromFHIRIdentifier } from "../datatypeComponents/IdentifierEntry";
import { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import CodeEntry from "../datatypeComponents/CodeEntry";

const ResearchSubjectSubjectStateEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [researchSubjectSubjectStateEntryState, setResearchSubjectSubjectStateEntryState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingSubjectStateEntry = {
            code: "", startDate: "", endDate: "", reason: ""
        };
        if (startingValue) {
            if (startingValue.extension) { startingSubjectStateEntry.extension = startingValue.extension; }
            if (startingValue.code) { startingSubjectStateEntry.code = startingValue.code; }
            if (startingValue.startDate) { startingSubjectStateEntry.startDate = startingValue.startDate; }
            if (startingValue.endDate) { startingSubjectStateEntry.endDate = startingValue.endDate; }
            if (startingValue.reason) { startingSubjectStateEntry.reason = startingValue.reason; }
        }
        setResearchSubjectSubjectStateEntryState(JSON.parse(JSON.stringify(startingSubjectStateEntry)));
    }, []);

    useEffect((() => {
        if (Object.keys(researchSubjectSubjectStateEntryState).length > 0) {
            let newSubjectStateEntry = {};
            if (researchSubjectSubjectStateEntryState.extension) { newSubjectStateEntry.extension = researchSubjectSubjectStateEntryState.extension; }
            if (researchSubjectSubjectStateEntryState.code && Object.keys(researchSubjectSubjectStateEntryState.code).length > 0) {
                newSubjectStateEntry.code = researchSubjectSubjectStateEntryState.code;
            }
            if (researchSubjectSubjectStateEntryState.startDate) {
                newSubjectStateEntry.startDate = researchSubjectSubjectStateEntryState.startDate;
            }
            if (researchSubjectSubjectStateEntryState.endDate) {
                newSubjectStateEntry.endDate = researchSubjectSubjectStateEntryState.endDate;
            }
            if (researchSubjectSubjectStateEntryState.reason && Object.keys(researchSubjectSubjectStateEntryState.reason).length > 0) {
                newSubjectStateEntry.reason = researchSubjectSubjectStateEntryState.reason;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newSubjectStateEntry }; });
        }
    }), [researchSubjectSubjectStateEntryState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div>
                <div style={{ marginLeft: "24px" }}>
                    {startingValue.code && <div><b>State: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.code} />
                        <br /><br /></div>}
                    {startingValue.startDate && <p><b>Date started: </b>{getDateTimeDisplay(startingValue.startDate)}</p>}
                    {startingValue.endDate && <p><b>Date ended: </b>{getDateTimeDisplay(startingValue.endDate)}</p>}
                    {startingValue.reason && <div><b>Reason: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.reason} />
                        <br /><br /></div>}

                </div>
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(researchSubjectSubjectStateEntryState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='code' fieldLabel='Progress state'
                    startingValue={researchSubjectSubjectStateEntryState.code}
                    setResourceState={setResearchSubjectSubjectStateEntryState} />
                <DateTimeEntry elementName='startDate' fieldLabel='Start date'
                    startingValue={researchSubjectSubjectStateEntryState.startDate}
                    setResourceState={setResearchSubjectSubjectStateEntryState} />
                <DateTimeEntry elementName='endDate' fieldLabel='End date'
                    startingValue={researchSubjectSubjectStateEntryState.endDate}
                    setResourceState={setResearchSubjectSubjectStateEntryState} />
                <CodeableConceptEntry elementName='reason' fieldLabel='Reason'
                    startingValue={researchSubjectSubjectStateEntryState.reason}
                    setResourceState={setResearchSubjectSubjectStateEntryState} />
            </div>
        </>
    }
}

const ResearchSubjectSubjectMilestoneEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [researchSubjectSubjectMilestoneEntryState, setResearchSubjectSubjectMilestoneEntryState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingMilestoneEntry = {
            milestone: "", date: "", reason: []
        };
        if (startingValue) {
            if (startingValue.extension) { startingMilestoneEntry.extension = startingValue.extension; }
            if (startingValue.milestone) { startingMilestoneEntry.milestone = startingValue.milestone; }
            if (startingValue.date) { startingMilestoneEntry.date = startingValue.date; }
            if (startingValue.reason) { startingMilestoneEntry.reason = startingValue.reason; }
        }
        setResearchSubjectSubjectMilestoneEntryState(JSON.parse(JSON.stringify(startingMilestoneEntry)));
    }, []);

    useEffect((() => {
        if (Object.keys(researchSubjectSubjectMilestoneEntryState).length > 0) {
            let newMilestoneEntry = {};
            if (researchSubjectSubjectMilestoneEntryState.extension) { newMilestoneEntry.extension = researchSubjectSubjectMilestoneEntryState.extension; }
            if (researchSubjectSubjectMilestoneEntryState.milestone && Object.keys(researchSubjectSubjectMilestoneEntryState.milestone).length > 0) {
                newMilestoneEntry.milestone = researchSubjectSubjectMilestoneEntryState.milestone;
            }
            if (researchSubjectSubjectMilestoneEntryState.date) {
                newMilestoneEntry.date = researchSubjectSubjectMilestoneEntryState.date;
            }
            if (researchSubjectSubjectMilestoneEntryState.reason &&
                Array.isArray(researchSubjectSubjectMilestoneEntryState.reason) &&
                researchSubjectSubjectMilestoneEntryState.reason.length > 0) {
                newMilestoneEntry.reason = researchSubjectSubjectMilestoneEntryState.reason;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newMilestoneEntry }; });
        }
    }), [researchSubjectSubjectMilestoneEntryState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div>
                <div style={{ marginLeft: "24px" }}>
                    {startingValue.milestone && <div><b>Milestone: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.milestone} />
                        <br /><br /></div>}
                    {startingValue.date && <p><b>Date reached: </b>{getDateTimeDisplay(startingValue.date)}</p>}
                    {startingValue.reason && <p><b>Reason: </b>{getCodeableConceptDisplayForObjectOrArray(startingValue.reason)}</p>}
                </div>
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(researchSubjectSubjectMilestoneEntryState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='milestone' fieldLabel='Milestone'
                    startingValue={researchSubjectSubjectMilestoneEntryState.milestone}
                    setResourceState={setResearchSubjectSubjectMilestoneEntryState} />
                <DateTimeEntry elementName='startDdateate' fieldLabel='Date reached'
                    startingValue={researchSubjectSubjectMilestoneEntryState.date}
                    setResourceState={setResearchSubjectSubjectMilestoneEntryState} />
                <ArrayEntry datatype='CodeableConcept' elementName='reason' fieldLabel='Reason'
                    startingValue={researchSubjectSubjectMilestoneEntryState.reason}
                    setResourceState={setResearchSubjectSubjectMilestoneEntryState} />
            </div>
        </>
    }
}

const ResearchSubjectDisplay = ({ foi }) => {
    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const displayTitle = parentResourceDetail?.displayTitle;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));

    const [researchSubjectResourceState, setResearchSubjectResourceState] = useState({});

    let description;
    if (resourceJson.extension) {
        for (const extension of resourceJson.extension) {
            if (extension.url === "http://hl7.org/fhir/StructureDefinition/artifact-description" &&
                extension.valueMarkdown
            ) {
                description = extension.valueMarkdown;
            }
        }
    }

    useEffect(() => {
        dispatch(changeTopNavigationElements(["Subject", "Study", "Status", "Consent"]));
        dispatch(changeBrowserTabTitle("FEvIR ResearchSubject - " + displayTitle));
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setResearchSubjectResourceState(olderVersionJson);
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson) {
            setResearchSubjectResourceState(resourceJson);
        }
    }, [resourceJson]);

    useEffect(() => {
        dispatch(changeTool("FEvIR®: ResearchSubject " + (editMode ? "Builder" : "Viewer")));
    }, [editMode]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateNarrativeElement(researchSubjectResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.text]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "identifier", "ArrayOfIdentifier", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.identifier]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "status", "code", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.status]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "period", "Period", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.period]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "study", "Reference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.study]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "subject", "Reference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.subject]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "subjectState", "ArrayOfResearchSubjectSubjectState", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.subjectState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "subjectMilestone", "ArrayOfResearchSubjectSubjectMilestone", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.subjectMilestone]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "comparisonGroup", "ArrayOfCodeableReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.comparisonGroup]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(researchSubjectResourceState, "consent", "ArrayOfReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [researchSubjectResourceState.consent]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div>
        <>{researchSubjectResourceState.id && <>
            <div style={{ marginTop: "12px" }}>
                <h3 id="subject">Subject</h3>
                <div style={{ marginLeft: "24px" }}>
                    {editMode ?
                        <NarrativeEntry elementName="text"
                            startingValue={researchSubjectResourceState.text}
                            setResourceState={setResearchSubjectResourceState} />
                        :
                        <>{
                            (researchSubjectResourceState?.text?.div &&
                                researchSubjectResourceState.text.status &&
                                researchSubjectResourceState.text.status !== "empty")
                                ?
                                <DisplayFromFHIRXhtml xhtml={researchSubjectResourceState.text.div} />
                                :
                                <p>[Narrative summary not generated.]</p>
                        }</>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='Identifier' elementName='identifier'
                                    fieldLabel='Identifier'
                                    startCollapsed
                                    startingValue={researchSubjectResourceState.identifier}
                                    setResourceState={setResearchSubjectResourceState} />
                            </>
                            :
                            <>
                                {Array.isArray(researchSubjectResourceState.identifier) &&
                                    researchSubjectResourceState.identifier.map((identifier, identifierIndex) => {
                                        return <div key={identifierIndex}><b>Identifier: </b>{displayStringFromFHIRIdentifier(identifier)}</div>
                                    })}
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ReferenceEntry elementName='subject'
                                    fieldLabel='Subject'
                                    startCollapsed enableCreation={true}
                                    referencedResourceTypes={["Patient", "Group", "Specimen", "Device",
                                        "Medication", "Substance", "SubstanceDefinition",
                                        "BiologicallyDerivedProduct"]}
                                    startingValue={researchSubjectResourceState.subject}
                                    setResourceState={setResearchSubjectResourceState} />
                            </>
                            :
                            <><b>Reference to Subject: </b>
                                {researchSubjectResourceState.subject ?
                                    <DisplayFromFHIRReference reference={researchSubjectResourceState.subject} />
                                    :
                                    <p>Reference to subject is missing.</p>
                                }
                            </>
                    }
                    {description && <div>
                        <b>Description: </b><DisplayFromFHIRMarkdown markdown={description} />
                        <br /><br />
                    </div>}
                    {editMode ?
                        <CodeEntry elementName='status' fieldLabel='Status'
                            allowedValues={['draft', 'active', 'retired', 'unknown']}
                            startingValue={researchSubjectResourceState.status}
                            setResourceState={setResearchSubjectResourceState} />
                        :
                        <>{researchSubjectResourceState.status && <p><b>Status: </b>{researchSubjectResourceState.status}</p>}</>
                    }
                </div>
                <h3 id="study">Study</h3>
                <div style={{ marginLeft: "24px" }}>
                    {editMode ?
                        <ReferenceEntry elementName='study'
                            fieldLabel='Study'
                            startCollapsed
                            startingValue={researchSubjectResourceState.study}
                            setResourceState={setResearchSubjectResourceState} />
                        :
                        <><b>Reference to Study: </b>
                            {researchSubjectResourceState.study ?
                                <DisplayFromFHIRReference reference={researchSubjectResourceState.study} />
                                :
                                <p>Reference to study is missing.</p>
                            }
                        </>
                    }
                </div>
                <h3 id="status">Status</h3>
                <div style={{ marginLeft: "24px" }}>
                    {editMode ?
                        <PeriodEntry elementName='period' fieldLabel='Period'
                            startingValue={researchSubjectResourceState.period}
                            setResourceState={setResearchSubjectResourceState} />
                        :
                        <>{researchSubjectResourceState.period && <p><b>Period of participation: </b>{displayStringFromFHIRPeriod(researchSubjectResourceState.period)}</p>}</>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='ResearchSubjectSubjectState'
                                elementName='subjectState' startCollapsed
                                fieldLabel='Subject State'
                                startingValue={researchSubjectResourceState.subjectState}
                                setResourceState={setResearchSubjectResourceState} />
                        </>
                        :
                        <>
                            {Array.isArray(researchSubjectResourceState.subjectState) &&
                                researchSubjectResourceState.subjectState.map((entry, entryIndex) => {
                                    return <div key={entryIndex}>
                                        <p><b>Subject State {entryIndex + 1}: </b></p>
                                        <div style={{ marginLeft: "24px" }}>
                                            {entry.code && <div><b>State: </b><DisplayFromFHIRCodeableConcept codeableConcept={entry.code} />
                                                <br /><br /></div>}
                                            {entry.startDate && <p><b>Date started: </b>{getDateTimeDisplay(entry.startDate)}</p>}
                                            {entry.endDate && <p><b>Date ended: </b>{getDateTimeDisplay(entry.endDate)}</p>}
                                            {entry.reason && <div><b>Reason: </b><DisplayFromFHIRCodeableConcept codeableConcept={entry.reason} />
                                                <br /><br /></div>}
                                        </div>
                                    </div>
                                })}
                        </>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='ResearchSubjectSubjectMilestone'
                                elementName='subjectMilestone' startCollapsed
                                fieldLabel='Subject Milestone'
                                startingValue={researchSubjectResourceState.subjectMilestone}
                                setResourceState={setResearchSubjectResourceState} />
                        </>
                        :
                        <>
                            {Array.isArray(researchSubjectResourceState.subjectMilestone) &&
                                researchSubjectResourceState.subjectMilestone.map((entry, entryIndex) => {
                                    return <div key={entryIndex}>
                                        <p><b>Subject Milestone {entryIndex + 1}: </b></p>
                                        <div style={{ marginLeft: "24px" }}>
                                            {entry.milestone && <div><b>Milestone: </b><DisplayFromFHIRCodeableConcept codeableConcept={entry.milestone} />
                                                <br /><br /></div>}
                                            {entry.date && <p><b>Date reached: </b>{getDateTimeDisplay(entry.date)}</p>}
                                            {entry.reason && <p><b>Reason: </b>{getCodeableConceptDisplayForObjectOrArray(entry.reason)}</p>}
                                        </div>
                                    </div>
                                })}
                        </>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='CodeableReference'
                                elementName='comparisonGroup' startCollapsed
                                fieldLabel='Comparison Group' startingResourceType="Group"
                                referencedResourceTypes={["Group"]}
                                startingValue={researchSubjectResourceState.comparisonGroup}
                                setResourceState={setResearchSubjectResourceState} />
                        </>
                        :
                        <>
                            {Array.isArray(researchSubjectResourceState.comparisonGroup) &&
                                researchSubjectResourceState.comparisonGroup.map((entry, entryIndex) => {
                                    return <div key={entryIndex}>
                                        <p><b>Comparison Group {entryIndex + 1}: </b></p>
                                        <div style={{ marginLeft: "24px" }}>
                                            {entry && <div><DisplayFromFHIRCodeableReference codeableRefence={entry} />
                                                <br /><br /></div>}
                                        </div>
                                    </div>
                                })}
                        </>
                    }
                </div>
                <h3 id="consent">Consent</h3>
                <div style={{ marginLeft: "24px" }}>
                    {editMode ?
                        <ArrayEntry datatype='Reference' elementName='consent' fieldLabel='Consent'
                            enableCreation={true} startCollapsed
                            startingResourceType="Consent"
                            referencedResourceTypes={["Consent"]}
                            startingValue={researchSubjectResourceState.consent}
                            setResourceState={setResearchSubjectResourceState} />
                        :
                        <>
                            {(researchSubjectResourceState.consent?.length === 1) &&
                                <p><b>Consent: </b><DisplayFromFHIRReference reference={researchSubjectResourceState.consent[0]} /></p>}
                            {(researchSubjectResourceState.subject?.length > 1) && researchSubjectResourceState.consent.map((consent, consentIndex) => {
                                return <div key={consentIndex}>
                                    <div><b>Consent: </b><DisplayFromFHIRReference reference={consent} /></div>
                                </div>
                            })}
                        </>
                    }


                </div>
            </div>
        </>}</>
    </div>
}

export default ResearchSubjectDisplay;
export { ResearchSubjectSubjectStateEntry, ResearchSubjectSubjectMilestoneEntry };